// UserRoleDrawer.jsx
import { AnimatePresence, motion } from "framer-motion";
import React, { useContext, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { BiCommentDetail } from "react-icons/bi";
import { FaFilter } from "react-icons/fa";
import { FaTag } from "react-icons/fa6";
import { FiUserX } from "react-icons/fi";
import { IoMdDoneAll } from "react-icons/io";
import { MdError, MdSwapHoriz } from "react-icons/md";
import { PiArrowBendUpLeft } from "react-icons/pi";
import { RxCross1 } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { ApproveRejctRequest, AuditObjectTypes, RoleResponseModel, UserRequestTable } from "../../_core/_model.ts";
import { ApproveOrReject, GetUsers } from "../../_core/_request.ts";
import { allAccessRoleID, IsAdminUser } from "../../Constants.ts";
import { useAppContext } from "../../context/AppContext.tsx";
import { AuthContext } from "../../context/AuthContext.js";
import { defaultTheme } from "../../styles/themes/defaultTheme.js";
import SavingIndicator from "../../UIComponents/SavingIndicator.tsx";
import { getMyLocalTime } from "../../Utilities/Utilities.ts";
import { UserRequestRole } from "../Forms/UserRequest/_core/_models.ts";
import { RoleGroup } from "../Roles/_core/_model.ts";
import GroupExpandView from "../Roles/GroupExpandView.tsx";
import DimensionFilter from "../Tools/DimensionFilter.tsx";
import Popup from "../Tools/Popup.tsx";
import TooltipButton from "../Tools/TooltipButton.tsx";
import UserCell from "../Tools/UserCell.tsx";
import RoleForConditions from "./RoleForConditions.tsx";
import UserRequestDetails from "./UserRequestDetails.tsx";
import ComponentLayout from "../Layouts/ComponentLayout.tsx";
import { useJoyride } from "../../UIComponents/JoyrideTour/JoyrideContext.tsx";
import RoleDetailsOnTitle from "../Roles/RoleDetailsOnTitle.tsx";

interface request {
    selectedUser: UserRequestTable,
    onClose: (refresh: boolean) => void
}

interface roleWithText {

}

interface exclItem {
    roleId: number,
    condition: string
}
export default function ApprovalOptions({ selectedUser, onClose }: request) {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDimensions, setSelectedDimensions] = useState<any[]>([]);
    const [assignedRoles, setAssignedRoles] = useState<RoleResponseModel[]>([]);
    const [selectedGroup, setSelectedGroup] = useState<RoleGroup>();
    const [activeTab, setActiveTab] = useState('details');
    const navigate = useNavigate();

    const [badgeKey, setBadgeKey] = useState(0);
    const [excludedRoleIds, setExcludedRoleIds] = useState<exclItem[]>([]);
    const [popupMessage, setPopupMessage] = useState({ open: false, type: "", comment: "" });
    const { roles, dimensions, allRoleGroups, setAllUsers } = useAppContext();
    const { user } = useContext(AuthContext);
    const { setSelectedTab } = useJoyride();

    useEffect(() => {

        setSelectedTab(activeTab,);
    }, [activeTab]);

    const [formData, setFormData] = useState<ApproveRejctRequest>({
        stagingUserID: selectedUser.stagingUserID,
        userName: selectedUser.userName,
        rComment: "",
        aComment: "",
        action: 1,
        symabolicID: "",
        userIDAlias: "",
        email: selectedUser.email,
        password: "",
        languageCode: "",
        currencyCode: "",
        defaultMobilePage: "",
        enableExpertEntry: 1,
        navigatorHomepage: "",
        processProfile: "",
        primary: "",
        rowSecurity: 1,
        userRequestedBy: 1,
        userApprovedBy: user.userID,
        dimesionsRoles: {},
        internationalOnly: 0,
        customerDimension: 0,
        roleGroups: selectedUser.roleGroups == "" ? [] : selectedUser.roleGroups.split(",").map((g) => parseInt(g)),
        replaceRoles: selectedUser.replaceRoles,
        dirtyFields: [],
        userID: 0
    });
    useEffect(() => {
        let vals: { [key: string]: UserRequestRole[] } = {};
        setFormData({
            stagingUserID: selectedUser.stagingUserID,
            userID: selectedUser.userID,
            rComment: "",
            userName: selectedUser.userName,
            aComment: "",
            action: 1,
            symabolicID: "",
            userIDAlias: "",
            email: selectedUser.email,
            password: "",
            languageCode: "",
            currencyCode: "",
            defaultMobilePage: "",
            enableExpertEntry: 1,
            navigatorHomepage: "",
            processProfile: "",
            primary: "",
            rowSecurity: 1,
            userRequestedBy: selectedUser.userRequestedBy,
            userApprovedBy: user.userID,
            dimesionsRoles: vals,
            internationalOnly: 0,
            customerDimension: 0,
            roleGroups: selectedUser.roleGroups == "" ? [] : selectedUser.roleGroups.split(",").map((g) => parseInt(g)),
            replaceRoles: selectedUser.replaceRoles,
            dirtyFields: [],
            personaID: 0
        });
        if (!(selectedUser.status == "" || selectedUser.status.toLowerCase() == "requested")) {
            setActionMessage({ type: "noAction", message: "No action needed — this request has already been handled." });
        }
        else
            setActionMessage({ type: null, message: "" });
        //let tRoles = x.data.filter((x)=>selectedUser.role);//.filter((x) => selectedUser.roles.indexOf(x.name) > -1);
        let tRoles: RoleResponseModel[] = [];
        let exList: exclItem[] = [];
        for (var dim in selectedUser.dimesionsRoles) {
            for (var indx in selectedUser.dimesionsRoles[dim]) {
                let curRole = selectedUser.dimesionsRoles[dim][indx];
                if (curRole.excluded) {
                    if (curRole.roleID != null) {
                        exList.push({ condition: curRole.conditions, roleId: curRole.roleID });
                    }
                }
                if (curRole.roleID != null && curRole.roleID > 0) {
                    let oRole = roles.find((r) => r.roleID == curRole.roleID);
                    if (typeof oRole != 'undefined')
                        tRoles.push(oRole)
                }
                else {
                    let tName = curRole.roleID == allAccessRoleID[dim] ? "Required all Access" : curRole.conditions;
                    let tempRole: RoleResponseModel = {
                        roleID: curRole.roleID,
                        roleName: tName,
                        roleCode: "",
                        effectiveDate: "",
                        status: "",
                        roleType: "",
                        description: "",
                        dataMapCode: dim,
                        notes: "",
                        dimensionName: dim,
                        weight: 0,
                        createdBy: 0,
                        dimensionID: 0,
                        filterConditions: tName,
                        changed: false,
                        _source: "",
                        dirtyFields: []
                    }
                    tRoles.push(tempRole);
                }
            }
        }
        if (selectedUser.roleGroups != "") {
            let gId = parseInt(selectedUser.roleGroups);
            let g = allRoleGroups.find((x) => x.roleGroupID == gId);
            setSelectedGroup(g);
        }
        setAssignedRoles([...tRoles]);
        setExcludedRoleIds([...exList]);
    }, [selectedUser])

    const updateRoles = (roles: RoleResponseModel[]) => {
        let vals: { [key: string]: UserRequestRole[] } = {};
        for (var indx in roles) {
            let curRole: RoleResponseModel = roles[indx];
            if (typeof vals[curRole.dataMapCode] != 'undefined')
                vals[curRole.dataMapCode].push({
                    conditions: "",
                    roleID: curRole.roleID,
                    stagingUserID: selectedUser.stagingUserID,
                    excluded: false
                });
            else
                vals[curRole.dataMapCode] = [{
                    conditions: "",
                    roleID: curRole.roleID,
                    stagingUserID: selectedUser.stagingUserID,
                    excluded: false
                }]
        }
        setFormData(prev => ({
            ...prev,
            dimesionsRoles: vals
        }));
    }

    useEffect(() => {
        if (Object.keys(assignedRoles).length > 0)
            updateRoles(assignedRoles);
    }, [assignedRoles])


    const totalWeight = roles.reduce((acc, role) => acc + role.weight, 0);
    const userWeight = assignedRoles.reduce((acc, role) => acc + (role.weight || 0), 0);

    const handleDrop = (role) => {
        if (!assignedRoles.some(r => r.roleID === role.roleID)) {
            setAssignedRoles(prev => [...prev, role]);
            setBadgeKey(prev => prev + 1);
        }
    };

    const handleRemove = (roleID) => {
        setAssignedRoles(prev => prev.filter(r => r.roleID !== roleID));
        setBadgeKey(prev => prev + 1);
    };

    const filteredAvailable = roles.filter(role =>
        (selectedDimensions.length === 0 || selectedDimensions.includes(role.dataMapCode)) &&
        (role.roleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            role.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const filteredAssigned = assignedRoles.filter(role =>
        (selectedDimensions.length === 0 || selectedDimensions.includes(role.dataMapCode)) &&
        (role.roleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            role.description.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // useEffect(() => {
    //     let tRoles = availableRoles;//.filter((x) => selectedUser.roles.indexOf(x.name) > -1);
    //     setAssignedRoles([...tRoles]);
    // }, [selectedUser])

    const [roleToReplace, setRoleToReplace] = useState<RoleResponseModel | null>(null);
    const [actionMessage, setActionMessage] = useState<{ type: string | null, message: string }>({ type: null, message: "" });

    const ApproveMe = (message: string) => {
        let tForm = formData;
        tForm.action = excludedRoleIds.length > 0 ? 2 : 1;
        tForm.aComment = message;
        if (excludedRoleIds.length > 0) {
            for (var d in tForm.dimesionsRoles) {
                for (var rIndx in tForm.dimesionsRoles[d]) {
                    let curRole = tForm.dimesionsRoles[d][rIndx];
                    if (mIExluded(curRole.roleID, curRole.conditions))
                        curRole.excluded = true;
                }
            }
        }
        setActionMessage({ type: "progress", message: "Processing..." });
        formData.dirtyFields = [
            "rComment",
            "aComment",
            "action",
            "userName",
            "email",
            "password",
            //"rowSecurity",
            "userApprovedBy",
            "dimesionsRoles",
            "roleGroups",
            "replaceRoles"
        ];
        ApproveOrReject(formData).then((x) => {
            GetUsers({ userID: 0, userName: "", email: "", roleID: null, roleGroupID: null, managerUserID: null, appliationAccess: null }).then((u) => {
                setAllUsers([...u.data]);
                setActionMessage({ type: "success", message: "User approved successfully." });
            })
        })
    }

    const RejectMe = (message: string) => {
        let tForm = formData;
        tForm.action = 0;
        tForm.rComment = message;
        setActionMessage({ type: "progress", message: "Processing..." });
        formData.dirtyFields = [
            "rComment",
            "aComment",
            "action",
            "userName",
            "email",
            "password",
            //  "rowSecurity",
            "userApprovedBy",
            "dimesionsRoles",
            "roleGroups",
            "replaceRoles"
        ];
        ApproveOrReject(formData).then((x) => {
            setActionMessage({ type: "success", message: "User request rejected." });
        })
    }

    useEffect(() => {
        if (actionMessage.type != null && actionMessage.type != "progress" && actionMessage.type != "noAction") {
            const timer = setTimeout(() => {
                setActionMessage({ type: null, message: "" });
                navigate("/requests")
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [actionMessage]);

    const mIExluded = (roleId: number | null, filterConditions: string) => {
        let excl = false;
        // if (roleId != null && roleId > 0) {
        excl = (excludedRoleIds.findIndex((x) => x.roleId == roleId) > -1);
        // }
        // else {
        //     excl = (excludedRoleIds.findIndex((x) => x.condition == filterConditions) > -1);
        // }
        return excl;
    }

    const [showFullComment, setShowFullComment] = useState(false);
    const commentText = (selectedUser.status.toLowerCase() === "approved" || selectedUser.status.toLowerCase() === "partially approved")
        ? selectedUser.aComment
        : selectedUser.rComment;

    const getRequestedRoles = () => {
        let rolesArr: UserRequestRole[] = [];
        for (var k in formData.dimesionsRoles) {
            rolesArr.push(...formData.dimesionsRoles[k]);
        }
        return rolesArr;
    }
    return (
        <ComponentLayout
            exButtons={<AnimatePresence>
                {actionMessage.type != null ? (
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 10 }}
                        style={{
                            margin: "0 auto",
                            width: "fit-content",
                            maxWidth: "90%",
                            pointerEvents: "none"
                        }}
                        className={`alert py-2 ${actionMessage.type === "noAction" ? "alert-info" : actionMessage.type === "progress" ? "alert-warning" : actionMessage.type === "success" ? "alert-success" : "alert-danger"
                            }`}
                    >
                        {
                            actionMessage.type === "noAction" ?
                                actionMessage.message :
                                <SavingIndicator {...{ color: defaultTheme.colors.primary, style: "spinner", message: actionMessage.message, type: "saving" }} />
                        }

                    </motion.div>
                ) :
                    (IsAdminUser(user) && user.isApprover == 1) &&
                    <div className="d-flex flex-column w-100 j_req_e_acn">
                        <div className="d-flex flex-row align-items-center justify-content-end gap-2 ">
                            <button className="btn btn-outline-danger " onClick={() => {
                                setPopupMessage({ comment: "", open: true, type: "reject" });
                            }}>
                                Reject
                            </button>
                            {
                                (excludedRoleIds.length == 0 || (excludedRoleIds.length < getRequestedRoles().length)) &&
                                <TooltipButton title={(excludedRoleIds.length > 0) ? "Approve request with only selected roles." : "Approve request with all requested roles."}>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            setPopupMessage({ comment: "", open: true, type: "approve" });
                                        }}
                                        disabled={
                                            assignedRoles
                                                .filter(r => !mIExluded(r.roleID, r.filterConditions))
                                                .some(role => role.roleID != null && role.roleID <= 0)
                                        }
                                    >
                                        {
                                            excludedRoleIds.length > 0 ? "Approve Partial" : "Approve"
                                        }
                                    </button>
                                </TooltipButton>
                            }
                        </div>
                        <span className="text-danger position-absolute text-nowrap" style={{ marginTop: "28px", right: "20px" }}>
                            {
                                assignedRoles
                                    .filter(r => !mIExluded(r.roleID, r.filterConditions))
                                    .some(role => role.roleID != null && role.roleID <= 0) &&
                                `You have to select/create roles for ${assignedRoles.filter(r => !mIExluded(r.roleID, r.filterConditions) && (r.roleID != null && r.roleID <= 0)).length} Requested items.`
                            }
                        </span>
                    </div>
                }
            </AnimatePresence>}
            instanceId={selectedUser.stagingUserID} objectType={AuditObjectTypes.UserRequest} title={
                <span className="d-flex flex-row align-items-center gap-2">
                    <div className='fw-normal j_req_e_title'>
                        Request for: <b>{selectedUser.userName}</b>
                    </div>
                    <span className='fs-3 px-2 mx-2 fw-normal' style={{ opacity: "0.2" }}>|</span>
                    <button className='btn px-0 j_req_bkbtn' onClick={() => {
                        navigate("/requests")
                    }}>
                        <div className='d-flex flex-row align-items-center gap-1 fw-500'>
                            <PiArrowBendUpLeft size={16} />
                            Back to all Requests
                        </div>
                    </button>
                </span>} bodyHeight={300} subHeader={undefined} cBody={
                    <>
                        {
                            roleToReplace ? (
                                <RoleForConditions
                                    roleToReplace={roleToReplace}
                                    onSelect={(newRole) => {
                                        const updatedRole = {
                                            ...newRole,
                                            description: newRole.description + " (Replaced Role)",
                                            _source: "replaced" // Add a custom marker
                                        };
                                        setAssignedRoles(prev =>
                                            prev.map(r => r.roleID === roleToReplace.roleID ? updatedRole : r)
                                        );
                                        setRoleToReplace(null);
                                    }}
                                    onClose={() => setRoleToReplace(null)}
                                />
                            ) :
                                <motion.div
                                    initial={{ x: 300 }}
                                    animate={{ x: 0 }}
                                    exit={{ x: 300 }}
                                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                                    className="h-100 px-2 py-4 overflow-y-auto bg-theme-card"
                                >
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div className="d-flex flex-wrap align-items-center small text-muted-theme mb-2 ps-2 j_req_e_meta">
                                            <span className="me-3 d-flex align-items-center gap-1">
                                                <strong>Created:</strong>
                                                <UserCell exUI={undefined} userId={selectedUser.userRequestedBy} />
                                                on {getMyLocalTime(selectedUser.createdAt)}
                                            </span>

                                            {selectedUser.status.toLowerCase() !== "requested" && (
                                                <>
                                                    <span className="me-3 d-flex align-items-center gap-1">
                                                        <strong>{selectedUser.status.toLowerCase() === "approved" ? "Approved:" :
                                                            (selectedUser.status.toLowerCase() == "Partially Approved") ? "Partially Approved" : "Rejected:"}</strong>
                                                        <UserCell exUI={undefined} userId={selectedUser.userApprovedBy} />
                                                        on {getMyLocalTime(selectedUser.approvedAt)}
                                                    </span>

                                                    {commentText && (
                                                        <div className="me-3 d-flex align-items-start gap-2 j_req_e_cmnt">
                                                            <BiCommentDetail size={16} style={{ marginTop: "2px" }} />
                                                            <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", flex: 1 }}>
                                                                {showFullComment
                                                                    ? commentText
                                                                    : commentText.slice(0, 20) + (commentText.length > 20 ? "..." : "")
                                                                }
                                                                {commentText.length > 20 && (
                                                                    <button
                                                                        className="btn btn-sm btn-link px-1 py-0 ms-2"
                                                                        onClick={() => setShowFullComment(!showFullComment)}
                                                                    >
                                                                        {showFullComment ? "Hide" : "View More"}
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <span className={`badge ms-auto ${(selectedUser.status.toLowerCase() === "approved" || selectedUser.status.toLowerCase() === "Partially Approved")
                                                        ? "bg-success-subtle text-success"
                                                        : "bg-danger-subtle text-danger"
                                                        }`}>
                                                        {selectedUser.status}
                                                    </span>
                                                </>
                                            )}
                                        </div>

                                    </div>

                                    {/* <div className="mb-4">
                <AccessIndicator score={userWeight} max={totalWeight} needLabel={true} />
            </div> */}
                                    <div className="d-flex border-bottom mb-4">
                                        {['details', 'roles'].map(tab => (
                                            <button
                                                key={tab}
                                                onClick={() => setActiveTab(tab)}
                                                className={`"bg-theme-card px-3 py-2 position-relative" ${`j_req_e_${tab}`}`}
                                                style={{
                                                    borderWidth: "0px 0px 4px 0px",
                                                    borderBottom: `4px solid ${activeTab === tab ? defaultTheme.colors.primary : 'transparent'}`,
                                                    fontWeight: activeTab === tab ? 'bold' : 'normal',
                                                    color: activeTab === tab ? defaultTheme.colors.primary : 'gray'
                                                }}
                                            >
                                                {tab === 'details' ? 'User Details' : (selectedUser.roleGroups != "") ? 'Requested Role for Group' : 'Requested Roles'}
                                                <motion.span
                                                    key={`${tab}-${badgeKey}`}
                                                    initial={{ scale: 0.8, opacity: 0 }}
                                                    animate={{ scale: 1.2, opacity: 1 }}
                                                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                                                    className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-info"
                                                    style={{ fontSize: '0.7rem', zIndex: 2 }}
                                                >
                                                    {tab == 'roles' && filteredAssigned.length}
                                                </motion.span>
                                            </button>
                                        ))}
                                    </div>
                                    <AnimatePresence mode="wait">
                                        {activeTab === 'roles' ? (
                                            (selectedUser.roleGroups != "") ?
                                                <div className="d-flex flex-column j_req_e_tbl">
                                                    <div className="d-flex flex-row align-items-center gap-1">
                                                        <span className="text-muted-theme">Group:</span><span><b>{selectedGroup?.roleGroupName}</b></span>
                                                    </div>
                                                    <GroupExpandView roleIDS={filteredAssigned.map((x) => x.roleID?.toString()).join(",")} tClass="px-0 py-1"
                                                        emptyUI={<div>
                                                            <div
                                                                className="text-center py-4"
                                                            >
                                                                <div className="d-flex justify-content-center align-items-center mb-3">
                                                                    <FiUserX size={48} color="#6c757d" />
                                                                </div>
                                                                <h5 style={{ color: "#6c757d", fontWeight: 500 }}>No roles selected</h5>
                                                                <p className="text-muted-theme" style={{ fontSize: "0.95rem" }}>
                                                                    You can copy role(s) from a User or select a Group.
                                                                </p>
                                                            </div>
                                                        </div>} />
                                                </div> :
                                                <motion.div
                                                    key="asked"
                                                    initial={{ opacity: 0, y: 10 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    exit={{ opacity: 0, y: 10 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <div className="d-flex flex-column gap-2 mb-3">
                                                        <input
                                                            className="form-control"
                                                            placeholder="Search roles..."
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                        <DimensionFilter needWarningAndCount={false} needLabel={true} searched={setSelectedDimensions} />
                                                    </div>
                                                    {filteredAssigned.map(role => (
                                                        <div
                                                            key={role.roleName}
                                                            className="j_req_e_tbl d-flex justify-content-between align-items-start ps-3 pe-1 py-3 mb-3 rounded shadow-sm text-truncate position-relative"
                                                            style={{
                                                                position: 'relative',
                                                                background: dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.bg || '#f1f1f1',
                                                                opacity: (mIExluded(role.roleID, role.filterConditions)) ? 0.6 : 1,
                                                                color: (mIExluded(role.roleID, role.filterConditions))
                                                                    ? '#adb5bd' // Light gray text
                                                                    : dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.color || '#333',
                                                                borderLeft: (mIExluded(role.roleID, role.filterConditions))
                                                                    ? '4px dashed #ced4da' // Disabled-style border
                                                                    : `4px solid ${dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.color || '#333'}`,
                                                                transition: 'all 0.2s ease',
                                                                width: '100%'
                                                            }}
                                                        >
                                                            {mIExluded(role.roleID, role.filterConditions) &&
                                                                <div
                                                                    className="position-absolute"
                                                                    style={{ top: '8px', left: '8px', zIndex: 10 }}
                                                                >
                                                                    <TooltipButton title="Not included for Approval">
                                                                        <div
                                                                            style={{
                                                                                backgroundColor: '#f8d7da',
                                                                                borderRadius: '50%',
                                                                                padding: '4px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)'
                                                                            }}
                                                                        >
                                                                            <RxCross1
                                                                                size={12}
                                                                                color={dimensions.find((r) => r.dimensionCode == role.dataMapCode)?.color || '#999'}
                                                                            />
                                                                        </div>
                                                                    </TooltipButton>
                                                                </div>
                                                            }
                                                            {/* Role Info */}
                                                            <div className="d-flex flex-column">
                                                                <div className="d-flex align-items-center gap-2 ">
                                                                    {role.roleID === allAccessRoleID[role.dataMapCode] ? <IoMdDoneAll /> : (role.roleID != null && role.roleID > 0) ? <FaTag /> : <FaFilter />}
                                                                    <TooltipButton maxWidth={750} title={(role.roleID != null && role.roleID > 0) ? <RoleDetailsOnTitle roleId={role.roleID.toString()} /> : role.filterConditions}>
                                                                        <span className="fw-bold" style={{ fontSize: "0.95rem" }}>{role.roleName}</span>
                                                                    </TooltipButton>
                                                                    {role._source === "replaced" && (
                                                                        <span className="badge bg-info-subtle text-info mb-1" style={{ width: "fit-content" }}>
                                                                            Selected via Replacement
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                {(selectedUser.status == "" || selectedUser.status.toLowerCase() == "requested") && role.roleID != null && role.roleID <= 0 && !mIExluded(role.roleID, role.filterConditions) && (
                                                                    <button
                                                                        className="btn btn-outline-secondary px-2 py-1 my-1"
                                                                        style={{ width: "160px" }}
                                                                        onClick={() => {
                                                                            setRoleToReplace(role);
                                                                        }}
                                                                    >
                                                                        <div className="d-flex flex-row align-items-center gap-1">
                                                                            Replace with a Role
                                                                            <MdSwapHoriz size={22} />
                                                                        </div>
                                                                    </button>
                                                                )}
                                                                <div className={mIExluded(role.roleID, role.filterConditions) ? "small" : "small text-muted-theme"}>{role.description}</div>
                                                            </div>

                                                            {/* Actions */}
                                                            {
                                                                (selectedUser.status == "" || selectedUser.status.toLowerCase() == "requested") &&
                                                                <div className="d-flex align-items-center gap-3" >
                                                                    <TooltipButton title={mIExluded(role.roleID, role.filterConditions) ? "Select for approval" : "Unselect for approval"}>
                                                                        <div className="form-check form-switch m-0">
                                                                            <input
                                                                                className="form-check-input form-switch"
                                                                                type="checkbox"
                                                                                checked={!mIExluded(role.roleID, role.filterConditions)}
                                                                                onChange={() => {
                                                                                    let rId = role.roleID;
                                                                                    if (rId != null) {
                                                                                        let pVal = excludedRoleIds;
                                                                                        // if (rId > 0) {
                                                                                        if (pVal.findIndex((p) => p.roleId == rId) > -1)
                                                                                            pVal = pVal.filter((p) => p.roleId != rId);
                                                                                        else
                                                                                            pVal.push({
                                                                                                roleId: rId,
                                                                                                condition: ""
                                                                                            });
                                                                                        //}
                                                                                        // else {
                                                                                        //     if (pVal.findIndex((p) => p.condition == role.filterConditions) > -1)
                                                                                        //         pVal = pVal.filter((p) => p.condition != role.filterConditions);
                                                                                        //     else
                                                                                        //         pVal.push({
                                                                                        //             roleId: -1,
                                                                                        //             condition: role.filterConditions
                                                                                        //         });
                                                                                        // }
                                                                                        setExcludedRoleIds([...pVal]);
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </TooltipButton>
                                                                    {/* <button
                                        onClick={() => handleRemove(role.roleName)}
                                        className="btn p-0"
                                        style={{ background: 'transparent' }}
                                    >
                                        <IoIosCloseCircle size={24} color="red" />
                                    </button> */}
                                                                </div>
                                                            }
                                                        </div>
                                                    ))}
                                                </motion.div>
                                        ) :
                                            <motion.div>
                                                <UserRequestDetails user={selectedUser} readOnly={(!(selectedUser.status == "" || selectedUser.status.toLowerCase() == "requested"))} formData={formData} setFormData={setFormData} />
                                            </motion.div>
                                        }
                                    </AnimatePresence >


                                    <Popup isOpen={popupMessage.open} modal={true}
                                        onClose={() => { setPopupMessage({ comment: "", open: false, type: "" }) }}
                                        title={popupMessage.type == "approve" ? "Approval comment" : "Rejection Comment"}
                                        body={<div>
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <label className="form-label fw-bold">Comment:</label>
                                                    <textarea name="email"
                                                        placeholder={popupMessage.type == "approve" ? "Enter a comment to Approve" : "Enter a reason to Reject"}
                                                        value={popupMessage?.comment}
                                                        onChange={(e) => {
                                                            setPopupMessage({ comment: e.target.value, open: true, type: popupMessage.type })
                                                        }
                                                        }
                                                        style={{ resize: "none" }}
                                                        className="form-control noresize" />
                                                </div>
                                                {
                                                    popupMessage.type == "approve" &&
                                                    <div className="col">
                                                        <Alert
                                                            variant="warning"
                                                            className="px-3 py-2"
                                                            style={{ borderLeft: "5px solid #ffc107", fontSize: "0.95rem" }}
                                                        >
                                                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                                                <MdError size={18} color="#ffc107" />
                                                                <span className="d-flex align-items-center gap-1 flex-wrap">
                                                                    Selected roles will
                                                                    <strong className="mx-1">{formData.replaceRoles ? "replace" : "add to"}</strong>
                                                                    existing roles.
                                                                    <span className="form-switch ms-1">
                                                                        <input
                                                                            type="checkbox"
                                                                            role="switch"
                                                                            className="form-check-input form-switch py-2"
                                                                            name="replaceRoles"
                                                                            id="replaceRoles"
                                                                            checked={formData.replaceRoles}
                                                                            onChange={(e) => {
                                                                                setFormData(prev => ({
                                                                                    ...prev,
                                                                                    replaceRoles: e.target.checked
                                                                                }));
                                                                            }}
                                                                            style={{ borderColor: defaultTheme.colors.border }}
                                                                        />
                                                                    </span>
                                                                </span>
                                                            </div>

                                                            <div className="text-muted-theme small mt-2 ms-4">
                                                                {formData.replaceRoles
                                                                    ? "All existing roles assigned to this user will be removed before applying the selected ones."
                                                                    : "Selected roles will be merged with the user’s existing roles — without removing any."}
                                                            </div>
                                                        </Alert>
                                                    </div>
                                                }
                                                <div className="d-flex flex-row w-100 justify-content-end">
                                                    <button className={popupMessage.comment.isEmpty() ? "btn btn-secondary" : "btn btn-primary"} disabled={popupMessage.comment.isEmpty()}
                                                        onClick={() => {
                                                            if (popupMessage.type == "approve")
                                                                ApproveMe(popupMessage.comment)
                                                            else
                                                                RejectMe(popupMessage.comment)
                                                            setPopupMessage({ comment: "", open: false, type: "" })
                                                        }}>OK</button>
                                                </div>
                                            </div>
                                        </div>} />
                                </motion.div >
                        }
                    </>
                } />
    );
}
